export default "__VITE_ASSET__523e2e9f__"